import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { observer } from "mobx-react-lite/dist"
import { useTheme } from "theme/useTheme"
import { ProposalsEditRecipientsStoreProvider, useProposalsEditRecipientsStore } from "./ProposalsEditRecipientsStore"
import ProposalsEditRecipientsLogo from "./ProposalsEditRecipientsLogo"
import ProposalsEditRecipientsSelectClient from "./ProposalsEditRecipientsSelectClient"
import ProposalsEditRecipientsSelectContacts from "./ProposalsEditRecipientsSelectContacts"

export default observer(function ProposalsEditRecipients() {
   const theme = useTheme()
   const proposalsEditRecipientsStore = useProposalsEditRecipientsStore()

   return <ProposalsEditRecipientsStoreProvider store={proposalsEditRecipientsStore}>
      <Box>
         <Typography variant="h4">Let's start with some basics</Typography>
         <Typography variant="body1">Choose your recipients and personalise things a bit.</Typography>
      </Box>

      <Box sx={{ mt: theme.spacing(8) }}>
         <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Choose your recipients</Typography>
         <Typography variant="caption">Select a client and choose who you’d like to send this to.</Typography>
      </Box>

      <Box sx={{ mt: theme.spacing(3) }}>
         <ProposalsEditRecipientsSelectClient />
      </Box>

      <Box sx={{ mt: theme.spacing(3) }}>
         <ProposalsEditRecipientsSelectContacts />
      </Box>

      <Box sx={{ mt: theme.spacing(3) }}>
         <ProposalsEditRecipientsLogo />
      </Box>
   </ProposalsEditRecipientsStoreProvider >
})
